export default __webpack_public_path__ + "static/media/dreamfest (10).f206b94e.jpg";